import Attendees from '@components/Attendees'
import { Company, CompanyHistoryProfile, ProfileType } from '@modules/search/types'

import useAttendees from '../hooks/useAttendees'
import useFetchProfile from '../hooks/useFetchProfile'

interface ConferenceAttendeesProps {
  companyId: number
  smallViewMode?: boolean
}

const ConferenceAttendees = (props: ConferenceAttendeesProps) => {
  const { companyId, smallViewMode } = props
  const { total, attendees, eventData, fetchNextPage } = useAttendees({ companyId })

  const { data: fullCompanyProfile } = useFetchProfile({ type: ProfileType.company, id: companyId, disabled: true })

  const { latest: companyData = {} as Company } = fullCompanyProfile || ({} as CompanyHistoryProfile)

  const isPrivateProfile = companyData?.isPrivate

  if (isPrivateProfile) {
    return null
  }

  return (
    <Attendees
      companyId={companyId}
      attendeesList={attendees}
      total={total}
      onLoadMore={fetchNextPage}
      eventData={eventData}
      smallViewMode={smallViewMode}
    />
  )
}

export default ConferenceAttendees
